export default "__VITE_PUBLIC_ASSET__822c2a56__"